import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// vehicle_brands — ยี่ห้อรถ
// ============================================================================
export const vehicleBrands = sqliteTable("fleet_vehicle_brands", {
  id: text("id").primaryKey(), // ULID
  name: text("name").notNull(),
  nameTh: text("name_th"),
  logoUrl: text("logo_url"),
  isActive: integer("is_active").notNull().default(1),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type VehicleBrand = typeof vehicleBrands.$inferSelect;
export type NewVehicleBrand = typeof vehicleBrands.$inferInsert;
